import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function CancelPage() {
    const navigate = useNavigate();

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <div style={styles.iconWrap}>
                    <svg viewBox="0 0 52 52" style={styles.icon}>
                        <circle cx="26" cy="26" r="25" fill="none" stroke="#94a3b8" strokeWidth="2" />
                        <path fill="none" stroke="#94a3b8" strokeWidth="3" strokeLinecap="round"
                            d="M18 18 l16 16 M34 18 l-16 16" />
                    </svg>
                </div>
                <h1 style={styles.heading}>No worries.</h1>
                <p style={styles.sub}>
                    You weren't charged. Whenever you're ready, your plan will be waiting.
                </p>
                <button style={styles.btnPrimary} onClick={() => navigate('/pricing')}>
                    Back to Pricing
                </button>
                <button style={styles.btnSecondary} onClick={() => navigate('/dashboard')}>
                    Go to Dashboard
                </button>
            </div>
        </div>
    );
}

const styles = {
    page: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #031f4a 0%, #0a2a5e 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Inter, system-ui, Arial, sans-serif',
        padding: '24px',
    },
    card: {
        background: '#fff',
        borderRadius: '20px',
        padding: '56px 48px',
        textAlign: 'center',
        maxWidth: '420px',
        width: '100%',
        boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
    },
    iconWrap: {
        marginBottom: '28px',
    },
    icon: {
        width: '72px',
        height: '72px',
    },
    heading: {
        fontSize: '2rem',
        fontWeight: '800',
        color: '#031f4a',
        margin: '0 0 12px',
    },
    sub: {
        fontSize: '1rem',
        color: '#64748b',
        lineHeight: '1.6',
        margin: '0 0 36px',
    },
    btnPrimary: {
        background: 'linear-gradient(135deg, #0a2a5e, #031f4a)',
        color: '#fff',
        border: 'none',
        borderRadius: '12px',
        padding: '14px 36px',
        fontSize: '1rem',
        fontWeight: '700',
        cursor: 'pointer',
        width: '100%',
        marginBottom: '12px',
        letterSpacing: '0.3px',
    },
    btnSecondary: {
        background: 'transparent',
        color: '#64748b',
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        padding: '13px 36px',
        fontSize: '0.95rem',
        fontWeight: '600',
        cursor: 'pointer',
        width: '100%',
    },
};
